export default "__VITE_ASSET__YpQNY04e__"